/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Run_Wait_Reason_ApprovalInputs */



/**
* | output |
* | --- |
* | "Waiting for approval" |
*
* @param {Agent_Run_Wait_Reason_ApprovalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_run_wait_reason_approval = /** @type {((inputs?: Agent_Run_Wait_Reason_ApprovalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Run_Wait_Reason_ApprovalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wartet auf Freigabe")
	return /** @type {LocalizedString} */ ("Waiting for approval")
});